import { SearchItem } from './types'

export const shortenText = (text: string): string => {
    if (!text) return ''
    const dotsNeeded = text.length >= 50
    let trimmed = text.substr(0, 50)
    trimmed = trimmed.substr(
        0,
        Math.min(trimmed.length, trimmed.lastIndexOf(' '))
    )
    return dotsNeeded ? trimmed + '...' : trimmed
}

export const formatDate = (created_at?: string) => {
    if (!created_at) return null
    const date = new Date(created_at)
    return new Intl.DateTimeFormat('nl-NL', {
        dateStyle: 'medium',
        timeStyle: 'medium',
    }).format(date)
}

export const isAllowed = (kedo: any, credential: string) => {
    if (kedo.user().isSuperAdmin()) return true
    const defdossiers = kedo.env().getCurrentEnvironmentDefDossiers()
    return defdossiers.some((dd: any) =>
        kedo.env().isAllowedDefDossier(credential, dd.id)
    )
}

export const fetchItems = async (kedo: any, search: string) => {
    const url = kedo.api().getContentDossierEndpoint() + '/search'
    const params = {
        params: {
            environment: kedo.env().getEnvironment().id,
            search,
            limit: 10,
        },
    }
    const response = await kedo.api().get(url, params)
    return response.data as SearchItem[]
}